/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez Cumbe
 * Date:         11/03/24 - 8:35
 * Module name:  is-authenticated
 * File name:    is-authenticated.guard.ts
 * IDE:          WebStorm
 */

import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {map, Observable} from 'rxjs';
import {inject} from '@angular/core';
import {ZbAuthManagerService} from '@zibanu/auth';

export const IsAuthenticatedGuard: CanActivateFn = (_route, _state): Observable<boolean | UrlTree> => {
  const authService = inject(ZbAuthManagerService);
  const router = inject(Router);
  return authService.isAuthenticated().pipe(
    map((authenticated: boolean) => {
      if (!authenticated) {
        router.navigate(['/home']).then();
        return false;
      }
      return true
    })
  );
};

